// import { DateFunctions as DateFunctions } from './date_functions';
// import store from '../../store';

class ClsIndexDb {


  static f_startIndexDb = function(db_name, object_store_name) {
    let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;
    // Open (or create) the database
    let open = indexedDB.open(db_name);
    open.onupgradeneeded = function() {
      // console.log(db_name, ' open.onupgradeneeded');
      let db = open.result;
      let store = db.createObjectStore(object_store_name, {keyPath: "id"});
    }
  };

  static f_setIndexDb = function(db_name, object_store_name, data_list) {
      let vm = this;
      // This works on all devices/browsers, and uses IndexedDBShim as a final fallback 
      let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

      // Open (or create) the database
      let open = indexedDB.open(db_name, 2);

      open.onsuccess = function() {
          let db = open.result;
          // Start a new transaction
          let tx = db.transaction(object_store_name, "readwrite");
          let store = tx.objectStore(object_store_name);
          for (let i in data_list) {
            store.put({'id': data_list[i]['id'], 'data': data_list[i]['data']});
          }
          // Close the db when the transaction is done
          tx.oncomplete = function() {
              db.close();
          };
      }
    };

  static f_getIndexDb = function(db_name, object_store_name, data_id) {
    return new Promise((resolve) => {
      let vm = this;

      // This works on all devices/browsers, and uses IndexedDBShim as a final fallback 
      let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

      // Open (or create) the database
      let open = indexedDB.open(db_name, 2);

      open.onsuccess = function() {
          let db = open.result;
          // Start a new transaction
          let tx = db.transaction(object_store_name, "readwrite");
          let store = tx.objectStore(object_store_name);
          // Query the data
          let store_obj = store.get(data_id);
          store_obj.onsuccess = function() {
            let store_data = store_obj.result;
            resolve(store_data);
          };
          // Close the db when the transaction is done
          tx.oncomplete = function() {
              db.close();
          };
      }
    });
  };


}

export { ClsIndexDb };
